import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  entities: [],
  error: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const creditPurchaseSlice = createSlice({
  name: "creditPurchase",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;

      if (action.payload.error.response &&
        action.payload.error.response.data &&
        action.payload.error.response.data.message
      ) {
        state.error = action.payload.error.response.data.message;
      }

      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    creditPurchaseCreated: (state) => {
      state.actionsLoading = false;
      state.error = null;
    },

    creditPurchaseFetched: (state) => {
      state.listLoading = false;
      state.error = null;
    },
  }
});
